module.exports = __webpack_public_path__ + "static/media/14UNEP14.592a184b.jpg";